<template>
  <div class="uses__container">
    <uses-content />
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import UsesContent from "../components/UsesContent.vue";
export default {
  components: { UsesContent, Footer },
  name: "Uses",
};
</script>
